import { createSlice } from "@reduxjs/toolkit";
export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState: [],
    reducers: {
        acknowledgeNotification: (state, { payload: id }) => {
            const notification = state.find(n => n.id = id);
            notification && (notification.acknowledged = true);
        },
        addNotification: (state, { payload: notification }) => ([...state, notification]),
        clearAllNotifications: () => [],
        removeNotification: (state, { payload: id }) => (state.filter((notification) => notification.id !== id)),
    },
    selectors: {
        getLatestNotification: (state) => state.at(-1),
        getAllNotifications: (state) => state,
        getNotificationById: (state, id) => state.find(n => n.id === id),
    },
});
//# sourceMappingURL=notificationsSlice.js.map